<template>
  <div class="H5_product">

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">


          

        <van-nav-bar
        :title="$t('other.a1745')"
        :left-text="$t('other.a1279')"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        />
        <van-swipe >
        <van-swipe-item  v-for="(image, index) in productData.images" :key="index">
            <img style="width:100%" v-lazy="image.image" />
        </van-swipe-item>
        </van-swipe>
       <div class="desc_box">
           <div class="title">{{$t('other.a179')}}</div>
           <div class="name">{{productData.name}}</div>
       </div>
       <div class="sku_box">
           <div class="title">{{$t('other.a1747')}}</div>
           <van-cell-group>
            <van-cell v-for="(item,index) in storeItem.storeItems " :key="index" :title="'sku:' +item.skuName" :value="$t('other.a1748') + item.storeNum " />
            </van-cell-group>
       </div>

       

       <div class="desc_box">
           <div class="title">{{$t('other.a318')}}</div>
           <van-field
                v-model="productData.description"
                autosize
                type="textarea"
                :placeholder="$t('other.a1746')"
                />
 
       </div>
      </van-pull-refresh>
      
      <van-submit-bar  :button-text="$t('other.a1742')" @submit="onSubmit" />
       
  </div>
</template>

<script>
import api from '../../../api/api'
import newOrdersApi from '../../../api/moudles/newOrders'
import utils from '../../../utils/utils'


export default {
data(){
return{
    images:[
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg',
    ],
    productData:{
        images:[]
    },
    isLoading:false,
    storeItem:{
        storeItems:[]
    },
    userId:JSON.parse(localStorage.getItem('userInfo')).userId
}
},
created(){
    this.getData()
    
},
methods:{
    getRecommond(){
        // catid=199414&itemid=191451719&shopid=8185809
        
        let str='catid='+this.storeItem.categoryData.catId+'&itemid='+this.storeItem.categoryData.itemId+'&shopid='+this.storeItem.categoryData.shopId
        
        let url=utils.getSimilaryData(this.storeItem.country.toLowerCase(),str)
        console.log('str',str)
        console.log('str',url)
        newOrdersApi
        .proxyHttps({
            type:0,
            url:url,
            headerMap:null
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    
    onSubmit(){
        console.log(this.storeItem)
        let id=this.storeItem.storeItems[0].userId
        if(id == this.userId){
             this.$dialog.alert({
            message: $t('other.a1703'),
           
            })
            return
        }

        this.storeItem.userId=this.userId
        api
        .copyStoreItem(this.storeItem)
        .then(res => {
          if(res.code === 200) {
            this.$dialog.alert({
            message: $t('other.a1749'),
            title:$t('other.a1708')
            });
            
          }else{
            this.$dialog.alert({
                message: res.msg,
                title:$t('other.a1709')
                });
          }
        })


    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('other.a1228'));
        this.isLoading = false;
       
      }, 1000);
    },

    onClickLeft(){
        this.$router.push({
            path:'/mh5/index',
            query:{
                country:this.$route.query.country
            }
        })
    },
    onClickRight(){

    },
    getData(){
        let id=this.$route.query.groupId
        let productId=this.$route.query.productId

        
        if(id){
            api
            .getStoreItemByGroupId({groupId:id})
            .then(res => {
            if(res.code === 200 ){
            this.storeItem=res.data

            this.storeItem.amount=0
            this.storeItem.price=[]

            
            
            this.storeItem.storeItems.forEach(i => {
                this.storeItem.amount+=i.stock
                if(i.price){

                    this.storeItem.price.push(i.price)
                }
            })
            console.log('id',this.storeItem)
            this.storeItem.price=[...new Set(this.storeItem.price)]
            if(this.storeItem.price.length> 1){
                this.storeItem.price.sort((a,b) => {return a-b})
            }


            console.log('id',res.data)
            this.getRecommond()
            }else{
            this.$message.warning(res.msg)
            }
            })
        }


        if(productId){
            api
            .getProductByproductId({productId:productId})
            .then(res => {
            if(res.code === 200 ){
            console.log('productId',res.data)
            this.productData=res.data
            }else{
            this.$message.warning(res.msg)
            }
            })

        }
    }

}
}

</script>
<style lang="scss" scoped>

.H5_product{
    width: 100%;
    background-color: #eee;
    margin-bottom: 5rem;

    .my-swipe {
        width: 100%;

        .van-swipe-item {
            color: #fff;
            font-size: 30px;
            line-height: 150px;
            text-align: center;
            background-color: #39a9ed;
        }
    }

    /deep/ .van-submit-bar__button{
        width: 100%;
    }

    .van-nav-bar{
        background-color: #409eff;


        
    }

    .title{
            font-size: 20px;
            padding: 0 15px;
            border-bottom: 0.04rem solid #eee;
        }

    .desc_box{
        background: #fff;
        border-radius: 5px;
        margin: 0 5px;

        

        .name{
            font-size: 16px;
            padding: 5px 15px;
            box-sizing: border-box;
        }
    }

    .sku_box{
        background: #fff;
        border-radius: 5px;
        margin:  5px;
        box-sizing: border-box;
        padding:5px;
    }

    

    /deep/ .van-nav-bar__text {
        color: #fff !important;
        font-size: 18px;
    }

    /deep/ .van-icon{
        color: #fff;
    }

    /deep/ .van-nav-bar__title{
        color:#fff
    }

    /deep/ .van-submit-bar{
        border-top: 0.1rem solid #eee;
        background-color: #eee;
    }


  
    

    
}

</style>